import OrderNotary from "./orderNotary";

export default class Order {

  static STATUS_CANCELLED = -1;
  static STATUS_DRAFT = 0;
  static STATUS_PENDING_VID = 1;
  static STATUS_PENDING_INSURANCE_VERIFICATION = 2;
  static STATUS_PENDING_SECOND_FORM_OF_ID = 3;
  static STATUS_NEW = 4;
  static STATUS_PICK_NOTARY = 5;
  static STATUS_GENERATE_SHIPPING_LABEL = 6;
  static STATUS_PENDING_E_SIGN = 7;
  static STATUS_PENDING_INK_SIGN = 8;
  static STATUS_COMPLETED = 9;
  static STATUS_SEALED = 10;

  static INTERNAL_STATUS_UNDER_REVIEW = 1;
  static INTERNAL_STATUS_ON_HOLD = 2;

  static GRANULAR_STATUS_TYPE_INTERNAL = 0;
  static GRANULAR_STATUS_TYPE_ORDER = 1;
  static GRANULAR_STATUS_TYPE_ORDER_NOTARY = 2;

  static CUSTOMER_LOCATION_REMOTE = 1;
  static CUSTOMER_LOCATION_IN_STORE = 2;

  static CONTRACT_OPTION_VID = 1;
  static CONTRACT_OPTION_SIGNING = 2;
  static CONTRACT_OPTION_SIGNING_VID = 3;
  static CONTRACT_OPTION_INSURANCE_VERIFICATION = 4;

  static SEAL_STATUS_QUEUED = 1;
  static SEAL_STATUS_FAILED = 2;
  static SEAL_STATUS_SEALED = 3;

  static DOC_DELIVERY_OPTION_UPLOAD = 1;
  static DOC_DELIVERY_OPTION_SHIPPING = 2;

  static CONTRACT_TYPE_ORIGINAL = 1;
  static CONTRACT_TYPE_RESIGN = 2;

  static ALERT_FILTER_INACTIVE = 1;

  static ORDER_CREATION_STEP_CUSTOMER = "customer";
  static ORDER_CREATION_STEP_VEHICLE = "vehicle";
  static ORDER_CREATION_STEP_CONTRACT = "contract";
  static ORDER_CREATION_STEP_DOCS = "docs";
  static ORDER_CREATION_STEP_CONFIRM = "confirm";

  static MAV_SHIPPING_LABEL_OPTION_NO = 0;
  static MAV_SHIPPING_LABEL_OPTION_YES = 1;

  static MAV_SHIPPING_LABEL_STATUS_NEW = 1;
  static MAV_SHIPPING_LABEL_STATUS_CREATED = 2;
  static MAV_SHIPPING_LABEL_STATUS_CANCEL = 3;

  static CA_DELIVERY_FORM_NO = 0;
  static CA_DELIVERY_FORM_YES = 1;
  static CA_DELIVERY_FORM_YES_BOTH_CONTRACTS = 2;

  static BILLING_STATUS_NOT_ELIGIBLE = 0;
  static BILLING_STATUS_FEES_UNSETTLED = 1;
  static BILLING_STATUS_FEES_SETTLED = 2;
  static BILLING_STATUS_SENT_TO_QB = 3;
  static BILLING_STATUS_PAID = 4;
  static BILLING_STATUS_IGNORED = 5;

  static ACCOUNTING_STATUS_NOT_SETTLED = 0;
  static ACCOUNTING_STATUS_SETTLED = 1;
  static ACCOUNTING_STATUS_IGNORED = 2;

  static INSURANCE_VERIFICATION_STATUS_PENDING = 1;
  static INSURANCE_VERIFICATION_STATUS_NOT_EXISTENT = 2;
  static INSURANCE_VERIFICATION_STATUS_COMPLETED = 3;

  static NOTARY_SERVICE_TYPE_STANDARD = 1;
  static NOTARY_SERVICE_TYPE_SECURE_OFFSITE = 2;
  static NOTARY_SERVICE_TYPE_MAV_PRIME = 3;

  static getStatusColor(status) {
    switch (status) {
      case this.STATUS_DRAFT:
        return 'draft';
      case this.STATUS_PENDING_VID:
        return 'pending-vid';
      case this.STATUS_NEW:
        return 'new';
      case this.STATUS_PENDING_INSURANCE_VERIFICATION:
        return 'pending-insuranceVerification';
      case this.STATUS_PENDING_SECOND_FORM_OF_ID:
        return 'pending-secondFormOfId';
      case this.STATUS_PICK_NOTARY:
        return 'pick';
      case this.STATUS_GENERATE_SHIPPING_LABEL:
        return 'generate-label'
      case this.STATUS_PENDING_E_SIGN:
        return 'pending-eSign';
      case this.STATUS_PENDING_INK_SIGN:
        return 'pending-inkSign';
      case this.STATUS_COMPLETED:
        return 'completed';
      case this.STATUS_SEALED:
        return 'sealed';
      case this.STATUS_CANCELLED:
        return 'cancelled';
      default:
        return 'dark';
    }
  }

  static getGranularStatusColor(status) {
    if (!status) return 'dark';

    const [statusType, statusId] = status.split("_").map(id => parseInt(id));

    switch (statusType) {
      case this.GRANULAR_STATUS_TYPE_INTERNAL:
        return 'secondary';
      case this.GRANULAR_STATUS_TYPE_ORDER_NOTARY:
        return OrderNotary.getGranularStatusColor(statusId);
      case this.GRANULAR_STATUS_TYPE_ORDER:
      default:
        return this.getStatusColor(statusId);
    }
  }

  static getStatusMap() {
    return {
      [this.STATUS_CANCELLED]: 'Canceled',
      [this.STATUS_DRAFT]: 'Draft',
      [this.STATUS_PENDING_VID]: 'Pending VID',
      [this.STATUS_NEW]: 'New Order',
      [this.STATUS_PENDING_INSURANCE_VERIFICATION]: 'Pending Insurance Verification',
      [this.STATUS_PENDING_SECOND_FORM_OF_ID]: 'Pending Customer 2nd ID',
      [this.STATUS_PICK_NOTARY]: 'Pick Notary',
      [this.STATUS_GENERATE_SHIPPING_LABEL]: 'Generating Label',
      [this.STATUS_PENDING_E_SIGN]: 'Pending E-sign',
      [this.STATUS_PENDING_INK_SIGN]: 'Pending Ink-sign',
      [this.STATUS_COMPLETED]: 'Completed',
      [this.STATUS_SEALED]: 'Sealed',
    };
  }

  static getStatusName(id) {
    return this.getStatusMap()[id];
  }

  static getInternalStatusMap() {
    return {
      [this.INTERNAL_STATUS_UNDER_REVIEW]: 'Under Review',
      [this.INTERNAL_STATUS_ON_HOLD]: 'On Hold',
    };
  }

  static getInternalStatusName(id) {
    return this.getInternalStatusMap()[id];
  }

  static getCustomerLocationMap() {
    return {
      [this.CUSTOMER_LOCATION_REMOTE]: 'Remote',
      [this.CUSTOMER_LOCATION_IN_STORE]: 'In store',
    };
  }

  static getCustomerLocationMap2() {
    return {
      [this.CUSTOMER_LOCATION_REMOTE]: 'Out of area (remote/offsite)',
      [this.CUSTOMER_LOCATION_IN_STORE]: 'In store',
    };
  }

  static getCustomerLocationName(id) {
    return this.getCustomerLocationMap()[id];
  }

  static getContractOptions() {
    return {
      [this.CONTRACT_OPTION_VID]: 'VerifyID Only',
      [this.CONTRACT_OPTION_INSURANCE_VERIFICATION]: 'Insurance Verification Only',
      [this.CONTRACT_OPTION_SIGNING]: 'Document Signing',
      [this.CONTRACT_OPTION_SIGNING_VID]: 'Document Signing + VerifyID',
    };
  }

  static getSalesManagerContractOptions() {
    return {
      [this.CONTRACT_OPTION_VID]: 'VerifyID Only',
      [this.CONTRACT_OPTION_INSURANCE_VERIFICATION]: 'Insurance Verification Only',
    };
  }

  static getContractTypeMap() {
    return {
      [this.CONTRACT_TYPE_ORIGINAL]: 'Original - Complete document package for signing',
      [this.CONTRACT_TYPE_RESIGN]: 'Resign - 1 or 2 documents that need resigning',
    };
  }

  static getContractTypeName(id) {
    return this.getContractTypeMap()[id];
  }

  static getAlertOptions() {
    return {
      [this.ALERT_FILTER_INACTIVE]: 'Inactive',
    };
  }

  static getDocDeliveryOptions() {
    return {
      [this.DOC_DELIVERY_OPTION_UPLOAD]: 'Upload my customer DOCS',
      [this.DOC_DELIVERY_OPTION_SHIPPING]: 'Shipping',
    };
  }

  static getRushOrderOptions(rushPriceLabel) {
    return {
      1: `Yes, I am striving for a faster completion time of 24-48 hours${rushPriceLabel ? ` at ${rushPriceLabel}` : ''}`,
      0: 'No, I am striving for a completion time of 3-5 business days',
    };
  }

  static getAOIOptions() {
    return {
      1: 'Yes (Highly Recommended) (It is mandatory for our group)',
      0: 'No (Our group requested NOT to collect the fingerprint on the Affidavit of Identity)',
    };
  }

  static getCalifornia448Options() {
    return {
      [this.CA_DELIVERY_FORM_NO]: "No, my dealership completes this form internally or uses an alternative",
      [this.CA_DELIVERY_FORM_YES_BOTH_CONTRACTS]: "Please assist with a full contract signing and a 448 form signing (2 separate signings)",
      [this.CA_DELIVERY_FORM_YES]: "Please assist with the 448 form only. I will upload this document to the order, provide the vehicle delivery date and time",
    }
  }

  static getLocationAllowed() {
    return {
      0: 'My customer must sign only at the address provided in the order, I have advised my customer. (Highly recommend. Learn more about the red flag below)',
      1: 'I approve location changes on this order including signing outside the chosen address, if requested by the customer. By making this selection, I acknowledge that all proof of residency requirements have been completed. No further action is required by Mavsign. (Learn more about the red flag below)',
    }
  }

  static getCalifornia448SpecialInstruction() {
    return {
      [this.CA_DELIVERY_FORM_YES_BOTH_CONTRACTS]: "Note to notary: this order requires two separate signings,each with its own fee. The first signing involves the standard document package, which the customer will sign in the presence of a notary. The second signing will occur at the time of vehicle delivery, where the notary will assist in completing a 448 form alongside the delivery driver and the customer. The delivery date and time will be arranged after the initial appointment, and you will receive confirmation for the second appointment before the delivery takes place.",
      [this.CA_DELIVERY_FORM_YES]: "Note to notary: this signing will take place with the delivery driver and the customer at the time the vehicle is delivered. The delivery date and time will take place the same day as this lead or within 24 hours. Please accept this lead if you're available."
    }
  }

  static decideInsuranceVerificationStatus(insuranceInformation, signer) {
    if (signer.hasInsurance === null) {
      return this.INSURANCE_VERIFICATION_STATUS_PENDING;
    }
    if (!signer.hasInsurance) {
      return this.INSURANCE_VERIFICATION_STATUS_NOT_EXISTENT;
    }
    if (!!signer.hasInsurance && !!insuranceInformation) {
      return this.INSURANCE_VERIFICATION_STATUS_COMPLETED;
    }
  }

  static getInsuranceVerificationStatusMap() {
    return {
      [this.INSURANCE_VERIFICATION_STATUS_PENDING]: 'Pending',
      [this.INSURANCE_VERIFICATION_STATUS_NOT_EXISTENT]: 'Not available',
      [this.INSURANCE_VERIFICATION_STATUS_COMPLETED]: 'Completed',
    }
  }

  static getInsuranceVerificationStatusName(id) {
    return this.getInsuranceVerificationStatusMap()[id];
  }

  static getInsuranceVerificationStatusColor(id) {
    switch (id) {
      case this.INSURANCE_VERIFICATION_STATUS_PENDING:
        return 'text-warning';
      case this.INSURANCE_VERIFICATION_STATUS_NOT_EXISTENT:
        return 'text-danger';
      case this.INSURANCE_VERIFICATION_STATUS_COMPLETED:
        return 'text-success';
      default:
        return 'text-dark';
    }
  }

  static getInsuranceVerificationStatusBadgeColor(id) {
    switch (id) {
      case this.INSURANCE_VERIFICATION_STATUS_PENDING:
        return 'warning';
      case this.INSURANCE_VERIFICATION_STATUS_NOT_EXISTENT:
        return 'danger';
      case this.INSURANCE_VERIFICATION_STATUS_COMPLETED:
        return 'success';
    }
  }
}